export default "__VITE_ASSET__D41PiR32__"